import { PayloadAction } from '@reduxjs/toolkit';
import { AddonState } from 'src/store/addon/types';
import { IClipArtResultCategory } from 'src/store/addon/types/clipArtTypes';
import update from 'immutability-helper';

export interface AppendSubcategoriesPayload {
  parentCategoryId: string;
  subcategories: IClipArtResultCategory[];
  hasMore?: boolean;
}

const appendClipArtSubcategoriesReducer = (
  state: AddonState,
  action: PayloadAction<AppendSubcategoriesPayload>,
) => {
  if (!action.payload) return state;

  const { parentCategoryId, subcategories, hasMore } = action.payload;
  const existingCategory = state.clipArtCategories[parentCategoryId];

  if (!existingCategory) return state;

  return update<AddonState>(state, {
    clipArtCategories: {
      [parentCategoryId]: {
        subCategories: {
          $push: subcategories,
        },
        ...(hasMore !== undefined ? { hasMore: { $set: hasMore } } : {}),
      },
    },
  });
};

export default appendClipArtSubcategoriesReducer;
